import http from '../../plugins/http.js';

const state = {
  intervalMinutes: 5,
  isShowUI: false,
  duringBackup: false,
  backupState: 'none', // 'none' | 'saved'
  list: []
}

const getters = {
  isShowUI: state => state.isShowUI,
  getIntervalMinutes: state => state.intervalMinutes,
  getDuringBackup: state => state.duringBackup,
  getList: state => state.list,
  getBackupState: state => state.backupState,
}

const mutations = {
  setIntervalMinutes (state, num) {
    state.intervalMinutes = num;
  },
  isShowUI (state, flag) {
    state.isShowUI = flag;
  },
  setList(state, list) {
    state.list = list;
  },
  setDuringBackup (state, flag) {
    state.duringBackup = flag;
  },
  setBackupState (state, type) {
    state.backupState = type;
  }
}

const actions = {
  async fetchList ({commit, state}, {draftId} = {}) {
    const resp = await http.get(`/api/user/draft/getdraftbackuplist?draftId=${draftId}`);
    let {data: resData} = resp.data;
    let list = resData || [];
    commit('setList', list.slice(0, 20));
    return state.list;
  },
  async createBackup ({commit, state}, {draftId} = {}) {
    const resp = await http.post('/api/user/draft/draftbackup', {
      draftId
    });
    let {code: code} = resp.data;
    if (code === 200) {
      let list = await this.dispatch('draftBackup/fetchList', {draftId});
      state.backupState = 'saved';
      return list;
    }
  },
  async revertBackup ({commit, state}, {draftId, versionId}={}) {
    const resp = await http.post('/api/user/draft/recovery', {
      uid: draftId, versionId
    });
    let {code: code} = resp.data;
    if (code === 200) {
      return true;
    }
  },

  async fetchList_c ({commit, state}, {draftId, cooperationDraftId} = {}) {
    const resp = await http.get(`/api/user/account/cooperation/draftList?id=${cooperationDraftId}`);
    let {data: resData} = resp.data;
    let list = resData || [];
    commit('setList', list.slice(0, 20));
    return state.list;
  },
  async createBackup_c ({commit, state}, {draftId, cooperationDraftId} = {}) {
    const resp = await http.post('/api/user/account/cooperation/addVersion', {
      id: cooperationDraftId
    });
    let {code: code} = resp.data;
    if (code === 200) {
      let list = await this.dispatch('draftBackup/fetchList_c', {draftId, cooperationDraftId});
      state.backupState = 'saved';
      return list;
    }
  },
  async revertBackup_c ({commit, state}, {draftId, versionId, cooperationDraftId}={}) {
    const resp = await http.post('/api/user/account/cooperation/recoveryDraft', {
      id: cooperationDraftId, versionId
    });
    let {code: code} = resp.data;
    if (code === 200) {
      return true;
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/draftBackup.js